import React from 'react'
import i18next from 'i18next'
import { Card, Button } from 'react-bootstrap'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import { Trans } from 'react-i18next'
import { format, parseISO } from 'date-fns'

const { t } = i18next

class UsersDocumentDetailsForm extends React.Component {
  static defaultProps = {
    users: [],
    closeForm: () => {},
  }

  state = {
    filter: '',
    sortData: { sort_column: '', sort_direction: '' },
  }

  getColumns = () => [
    {
      title: t('components.users.username', 'Username'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '20%' },
      sortable: true,
      data: 'username',
    },
    {
      title: t('components.users.first_name', 'Nome'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '20%' },
      sortable: true,
      data: 'first_name',
    },
    {
      title: t('components.users.last_name', 'Cognome'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '20%' },
      sortable: true,
      data: 'last_name',
    },
    {
      title: t('components.users.business_role', 'Ruolo'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '20%' },
      sortable: true,
      data: 'business_role_name',
    },
    {
      title: t('components.users.downloaded_at', 'Scaricato il'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '20%' },
      sortable: true,
      data: ({ rowData: { downloaded_at } }) => {
        return downloaded_at ? format(parseISO(downloaded_at), 'dd/MM/yyyy HH:mm::ss') : ''
      },
    },
    {
      title: t('components.users.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      data: ({ rowData }) => this.renderDetails(rowData),
    },
  ]

  renderDetails(rowData) {
    let { first_name, last_name, business_role_name, downloaded_at, username } = rowData
    return (
      <Card className="shadow-lg border-0 rounded-lg">
        <Card.Body className="text-center pb-2 pt-2">
          <h4 className="fw-bold text-primary">
            {first_name} {last_name}
          </h4>
          <p className="text-muted mb-0">
            <i className="fas fa-user me-2"></i> {username}
          </p>
          <p className="text-muted mb-0">
            <i className="fas fa-briefcase me-2"></i> {business_role_name}
          </p>
          <p className="text-muted mb-0">
            <i className="fas fa-download me-2"></i>{' '}
            {downloaded_at ? downloaded_at : t('components.documents.not_downloaded', 'Non ancora scaricato')}
          </p>
        </Card.Body>
      </Card>
    )
  }

  getData = (_index = 0, _chunkSize, sortData) => {
    this.setState({ sortData })
  }

  searchFilterUsers = () => {
    let { users: all_users } = this.props
    let { sortData } = this.state
    let users = [...all_users]

    let { sort_column, sort_direction } = sortData

    if (sort_column) {
      users = users.sort((a, b) => {
        let valueA = a[sort_column] || ''
        let valueB = b[sort_column] || ''

        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase()
          valueB = valueB.toLowerCase()
        }

        if (valueA < valueB) {
          return sort_direction === 'ASC' ? -1 : 1
        }
        if (valueA > valueB) {
          return sort_direction === 'ASC' ? 1 : -1
        }
        return 0
      })
    }

    return users
  }

  render() {
    let { users } = this.props
    let _users = this.searchFilterUsers()
    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="container">
            <div className="d-flex flex-column" style={{ height: '60vh' }}>
              <ResponsiveTable
                className="flex-fill"
                data={_users}
                getData={this.getData}
                columns={this.getColumns()}
                hideStatusBar={true}
                totalRecords={users.length}
              />
            </div>
          </div>
          <div className="border-top pt-2">
            <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
          </div>
        </div>
      </>
    )
  }
}

export default UsersDocumentDetailsForm
